import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-pagination',
  template: `
    <nav class="flex items-center gap-2">
      <button (click)="change(page - 1)" [disabled]="page <= 1">Anterior</button>
      <span>{{ page }} / {{ totalPages }}</span>
      <button (click)="change(page + 1)" [disabled]="page >= totalPages">Próxima</button>
    </nav>
  `
})
export class PaginationComponent {
  @Input() page = 1;
  @Input() pageSize = 12;
  @Input() total = 0;
  @Output() pageChange = new EventEmitter<number>();

  get totalPages() { return Math.max(1, Math.ceil(this.total / this.pageSize)); }

  change(p: number) { if (p >= 1 && p <= this.totalPages) this.pageChange.emit(p); }
}
